<template>
    <b-table
        id="salarios"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive
        :busy="configTable.load"
        show-empty
        hover
        bordered
        class="mb-0"
        head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhum salário mínimo encontrado.</p>
        </template>
        <template v-slot:head(selecionar)="{ item }">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template v-slot:cell(selecionar)="{ item }">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(item.codSalarioMinimo)" @change="toggleCheck($event, item)" />
        </template>
        <template v-slot:head(1)="{ item }">
            Ínicio da Vigência <i class="filter" :class="!isEmpty(filtro.dataInicioVigencia) || filtro.filtrarDataInicioVigencia == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Ínicio da Vigência', 'data', '', $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            <p class="text-left">
                {{ item.dataInicioVigencia }}
            </p>
        </template>
        <template v-slot:head(2)="{ item }">
            Valor (R$) <i class="filter" :class="!isEmpty(filtro.valor) || filtro.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor (R$)', 'numerico', '', $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            <p class="text-right" v-if="item.valor != null">
                {{ item.valor | currency }}
            </p>
        </template>
        <template v-slot:head(3)="{ item }">
            Usuário responsável pelo cadastro <i class="filter" :class="!isEmpty(filtro.usuario) || filtro.filtrarUsuario == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Usuário responsável pelo cadastro', 'texto', '', $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            <p class="text-left">
                {{ item.usuario }}
            </p>
        </template>
    </b-table>
</template>

<script>
    import formatarMixins from '../../mixins/formatarMixins';
    
export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'filtro'],
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el.codSalarioMinimo)) {
                        this.selecteds.push(el.codSalarioMinimo);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el.codSalarioMinimo)) {
                        const index = this.selecteds.indexOf(el.codSalarioMinimo);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item.codSalarioMinimo);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item.codSalarioMinimo);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        openFilter(campo, tipo, values, event) {
            this.$emit('openFilterPopup', campo, tipo, values, event);
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
